import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { SourceListItemHttpModel } from '@examdojo/source';
import { of } from 'rxjs';

@Injectable()
export class SourceListService extends AbstractSimpleListViewService<SourceListItemHttpModel> {
  constructor() {
    super();
  }

  readonly data$ = of([]);
  readonly loading$ = of(false);
  override hasItems$ = of(true);
}
